export default __webpack_public_path__ + "static/media/TVinsure-Benefit-of-New-Insurance.c995051f.png";